import { baseQuery } from '../baseQuery';

type ToggleLockResponse = {
  data: { success: boolean; locked: 0 | 1 };
};

export const putToggleTaskPin = async ({ taskId }: { taskId: number }) => {
  const data: ToggleLockResponse = await baseQuery('task/togglelock', {
    type: 'PUT',
    body: {
      task_ID: taskId,
    },
  });

  return data.data;
};
